import React from "react";
import PropTypes from "prop-types";
import LocalNavSoftLink from "../LocalNavSoftLink";

export default function CompanyFeatureAccessSection({
    hasCompanySelected,
    hasSuperAdmin,
    hasExperianAdmin,
    onOpenManageFeatures,
}) {
    if (!hasCompanySelected) return null;

    return (
        <>
            {(hasSuperAdmin || hasExperianAdmin) && (
                <a
                    id="preferences"
                    href="#"
                    role="button"
                    onClick={e => {
                        e.preventDefault();
                        onOpenManageFeatures();
                    }}
                    style={{ color: "#575755", textDecoration: "none" }}
                >
                    User/Company Features
                </a>
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="features-2"
                    destination="/admin/features/all-companies"
                    text="Features (All Companies)"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="clientadmin-feature-manager"
                    destination="/admin/features/list"
                    text="Feature Access Manager"
                    feature="clientadmin-feature-manager"
                />
            )}
            {hasSuperAdmin && (
                <LocalNavSoftLink
                    removeLi
                    id="feature-audit-log"
                    destination="/admin/feature-audit-log"
                    text="Feature Audit Log"
                />
            )}
        </>
    );
}

// Mark safe for LocalNavMenu structural expansion (must remain hook-free)
CompanyFeatureAccessSection.__localNavSection = true;

CompanyFeatureAccessSection.propTypes = {
    hasCompanySelected: PropTypes.bool.isRequired,
    hasSuperAdmin: PropTypes.bool.isRequired,
    hasExperianAdmin: PropTypes.bool.isRequired,
    onOpenManageFeatures: PropTypes.func.isRequired,
};
